import TablePage from './table_page.vue';

export default TablePage;
